import { Veranstaltung } from '../dtos.ts';
import { getOnlineToolName } from './getBezeichnungen/index.js';
import { unique } from './unique.ts';

type NameAndKuerzel = { name: string; kuerzel?: string };
export type WoParameter = {
  onlineTool?: Veranstaltung['onlineTool'];
  standortBlockungen?: { standort: NameAndKuerzel }[];
  raumBlockungen?: { raum: { location: NameAndKuerzel & { standort?: NameAndKuerzel | null } } }[];
};

/**
 * Orders by Präsenz locations first, then by Online locations
 *
 * Example:
 * a-bbb/6
 * x-yyy/10
 * Online (MS-Teams)
 * Online (Zoom)
 */
export function printMultiWo(data: readonly WoParameter[]): string | undefined {
  const praesenzWo: WoParameter[] = [];
  const onlineWo: WoParameter[] = [];

  for (const item of data) {
    (item.onlineTool ? onlineWo : praesenzWo).push(item);
  }

  const sortedStrings = [...getUniqueSortedWoStrings(praesenzWo), ...getUniqueSortedWoStrings(onlineWo)];

  if (sortedStrings.length > 0) {
    return sortedStrings.join(', ');
  } else {
    return undefined;
  }
}

function getUniqueSortedWoStrings(data: readonly WoParameter[]): string[] {
  return data
    .map((item) => printWo(item))
    .filter(unique)
    .filter((woString) => woString !== undefined)
    .toSorted();
}

export function printWo(data: WoParameter): string | undefined {
  if (data.onlineTool) {
    const toolName = getOnlineToolName({ onlineTool: data.onlineTool });
    return toolName ? `Online (${toolName})` : 'Online';
  }

  const standort = data.standortBlockungen?.at(0)?.standort;
  if (standort) {
    return standort.kuerzel ? `${standort.name} (${standort.kuerzel})` : standort.name;
  }

  const raumLocation = data.raumBlockungen?.at(0)?.raum.location;
  if (raumLocation) {
    return `${raumLocation.standort?.name ?? raumLocation.name} (${raumLocation.kuerzel})`;
  }

  return undefined;
}
